"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRICE_FONT_WEIGHT = exports.PRICE_DECORATION = exports.PRICE_SIZE = exports.PRICE_LAYOUT = void 0;
const react_1 = __importDefault(require("react"));
const next13_components_text_1 = __importStar(require("@gerenciatd/next13.components.text"));
Object.defineProperty(exports, "PRICE_FONT_WEIGHT", { enumerable: true, get: function () { return next13_components_text_1.TEXT_FONT_WEIGHT; } });
const next13_enums_segments_1 = require("@gerenciatd/next13.enums.segments");
const parsePrice = (number, decimals, decimalChar = ",", thousandChar = ".") => {
    let res = number;
    res = res.toString().replace(",", thousandChar);
    res = parseFloat(res).toFixed(decimals);
    res = res.replace(".", decimalChar);
    const splitNum = res.split(decimalChar);
    splitNum[0] = splitNum[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandChar);
    if (splitNum[1] !== "00") {
        res = splitNum.join(decimalChar);
    }
    else {
        res = splitNum[0];
    }
    return res;
};
const normalizePrice = (amount, decimals) => {
    const priceToShow = amount;
    if (!priceToShow && priceToShow !== 0) {
        return null;
    }
    if (!(typeof priceToShow === "number" || typeof priceToShow === "string")) {
        return null;
    }
    return parsePrice(priceToShow, decimals);
};
//layout: compact, default
//size: xl, l, m, s
// Enums
const enums_1 = require("./enums");
Object.defineProperty(exports, "PRICE_LAYOUT", { enumerable: true, get: function () { return enums_1.PRICE_LAYOUT; } });
Object.defineProperty(exports, "PRICE_SIZE", { enumerable: true, get: function () { return enums_1.PRICE_SIZE; } });
Object.defineProperty(exports, "PRICE_DECORATION", { enumerable: true, get: function () { return enums_1.PRICE_DECORATION; } });
const setSizeProps = (layout, size) => {
    let priceSize = null;
    let currencySize = null;
    let quoteSize = null;
    switch (size) {
        case enums_1.PRICE_SIZE.XXXL:
            priceSize = next13_components_text_1.TEXT_SIZE.DISPLAY1; // Se reemplaza en el scss
            if (layout == enums_1.PRICE_LAYOUT.COMPACT) {
                currencySize = next13_components_text_1.TEXT_SIZE.DISPLAY1;
                quoteSize = next13_components_text_1.TEXT_SIZE.TITLE3;
            }
            else {
                currencySize = next13_components_text_1.TEXT_SIZE.DISPLAY1;
                quoteSize = next13_components_text_1.TEXT_SIZE.DISPLAY1;
            }
            break;
        case enums_1.PRICE_SIZE.XXL:
            priceSize = next13_components_text_1.TEXT_SIZE.DISPLAY1;
            if (layout == enums_1.PRICE_LAYOUT.COMPACT) {
                currencySize = next13_components_text_1.TEXT_SIZE.TITLE4;
                quoteSize = next13_components_text_1.TEXT_SIZE.CAPTION1;
            }
            else {
                currencySize = next13_components_text_1.TEXT_SIZE.TITLE2;
                quoteSize = next13_components_text_1.TEXT_SIZE.TITLE2;
            }
            break;
        case enums_1.PRICE_SIZE.XL:
            priceSize = next13_components_text_1.TEXT_SIZE.TITLE1;
            if (layout == enums_1.PRICE_LAYOUT.COMPACT) {
                currencySize = next13_components_text_1.TEXT_SIZE.TITLE6;
                quoteSize = next13_components_text_1.TEXT_SIZE.CAPTION2;
            }
            else {
                currencySize = next13_components_text_1.TEXT_SIZE.TITLE4;
                quoteSize = next13_components_text_1.TEXT_SIZE.TITLE4;
            }
            break;
        case enums_1.PRICE_SIZE.L:
            priceSize = next13_components_text_1.TEXT_SIZE.TITLE2;
            if (layout == enums_1.PRICE_LAYOUT.COMPACT) {
                currencySize = next13_components_text_1.TEXT_SIZE.CAPTION1;
                quoteSize = next13_components_text_1.TEXT_SIZE.CAPTION3;
            }
            else {
                currencySize = next13_components_text_1.TEXT_SIZE.TITLE5;
                quoteSize = next13_components_text_1.TEXT_SIZE.TITLE5;
            }
            break;
        case enums_1.PRICE_SIZE.M_L:
            priceSize = next13_components_text_1.TEXT_SIZE.TITLE4;
            currencySize = next13_components_text_1.TEXT_SIZE.TITLE6;
            quoteSize = next13_components_text_1.TEXT_SIZE.TITLE6;
            break;
        case enums_1.PRICE_SIZE.S:
            priceSize = next13_components_text_1.TEXT_SIZE.CAPTION1;
            currencySize = next13_components_text_1.TEXT_SIZE.CAPTION1;
            quoteSize = next13_components_text_1.TEXT_SIZE.CAPTION1;
            break;
        case enums_1.PRICE_SIZE.XS:
            priceSize = next13_components_text_1.TEXT_SIZE.CAPTION2;
            currencySize = next13_components_text_1.TEXT_SIZE.CAPTION2;
            quoteSize = next13_components_text_1.TEXT_SIZE.CAPTION2;
            break;
        default:
        case enums_1.PRICE_SIZE.M:
            priceSize = next13_components_text_1.TEXT_SIZE.TITLE5;
            currencySize = next13_components_text_1.TEXT_SIZE.TITLE5;
            quoteSize = next13_components_text_1.TEXT_SIZE.TITLE5;
            break;
    }
    return {
        priceSize,
        currencySize,
        quoteSize,
    };
};
const Price = ({ layout, size, color, price, currency, quote, decoration, fontType, segment: segmentProp, cyData, custoObjectInfo, }) => {
    if (price < 0) {
        return null;
    }
    const priceToShow = normalizePrice(price, 2);
    let finalLayout = enums_1.PRICE_LAYOUT.DEFAULT;
    let priceSize = null;
    let currencySize = null;
    let quoteSize = null;
    if (layout && Object.values(enums_1.PRICE_LAYOUT).find((item) => item === layout)) {
        finalLayout = layout;
    }
    ({ priceSize, currencySize, quoteSize } = setSizeProps(finalLayout, size));
    const segment = (0, next13_enums_segments_1.getNormalizedSegment)(segmentProp);
    let editModal = null;
    if (custoObjectInfo) {
        editModal = custoObjectInfo.handler(custoObjectInfo.entryPoint);
    }
    return (react_1.default.createElement("div", { className: `price price-layout--${finalLayout} price-size--${size}`, "data-cy": cyData, onClick: editModal },
        react_1.default.createElement(next13_components_text_1.default, { className: "price--content", text: priceToShow, size: priceSize, color: color, display: "inline", decoration: decoration, fontType: fontType, segment: segment }),
        react_1.default.createElement("div", { className: "price--unity" },
            currency && (react_1.default.createElement(next13_components_text_1.default, { className: "price--currency", text: currency, size: currencySize, color: color, display: "inline", decoration: decoration, fontType: fontType, segment: segment })),
            react_1.default.createElement("div", { className: "price--quote" }, currency && quote && (react_1.default.createElement(next13_components_text_1.default, { className: "price--quote_text", text: `/${quote}`, size: quoteSize, color: color, display: "inline", decoration: decoration, fontType: fontType, segment: segment }))))));
};
Price.defaultProps = {
    size: enums_1.PRICE_SIZE.M,
    decoration: enums_1.PRICE_DECORATION.NONE,
    color: "grey6",
    fontType: next13_components_text_1.TEXT_FONT_WEIGHT.REGULAR,
    custoObjectInfo: null,
    cyData: "",
};
exports.default = Price;
//# sourceMappingURL=index.js.map